<template>
  <div class="behavior-container" style="position:relative">
    <div class="behavior-instruction left">
      支援←関わり方・姿勢→指示
    </div>
    <div class="behavior-instruction bottom">
      他力←本人の原動力→自力
    </div>
    <table ref="behavior-table">
      <div class="axis-current" ref="behavior-axis-current" :style="calculatePositionCurrent(chartDataCurrent.x, chartDataCurrent.y)"></div>
      <div class="axis-last" ref="behavior-axis-last" v-if="chartDataLast.isDisp" :style="calculatePositionLast(chartDataLast.x, chartDataLast.y)"></div>
      <tbody>
        <tr>
          <td>
            <div class="behavior-label top left">
              コツをつかめば自分でやり始めるタイプ<br />
              任せるが支援は怠らない
            </div>
          </td>
          <td>
            <div class="behavior-label top right">
              言われなくてもやるタイプ<br />
              権限移譲し責任を確認
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="behavior-label bottom left">
              不安なタイプ<br />
              具体的で詳細な指示と細かい進捗管理が必要
            </div>
          </td>
          <td>
            <div class="behavior-label bottom right">
              言われたことはやるタイプ<br />
              指示には積極的に従うので、定期的関わりが必要
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<style lang="scss" scoped>
$label-height: 50px;
$table-height: 220px;
$instruction-height: 40px;
$instruction-margin: 10px;
.behavior-container {
  width: 100%;
  height: $table-height + $instruction-height;
  display: flex;
  align-items: center;
  justify-content: center;
}
.axis-current {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #174a84 !important;
  z-index: 99;
}
.axis-last {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff4500 !important;
  z-index: 98;
}
table {
  width: calc(100% - #{$instruction-height});
  height: $table-height;
  border-collapse: collapse;
  position: relative;
}
td {
  border: 1px solid $chart-grid-color;
  width: 50%;
  height: 50%;
  padding: $spacing-small;
  font-size: 0.9rem;
  color: #888;
  opacity: 0.5;
  position: relative;
}
.behavior-instruction {
  position: absolute;
}
.behavior-instruction.left {
  writing-mode: vertical-rl;
  left: -($instruction-margin);
}
.behavior-instruction.bottom {
  bottom: -($instruction-margin);
}
</style>
<script lang="ts">
import { Prop, Ref } from "vue-property-decorator";
import ChartMixin from "../../helpers/mixins/chart";
export default class LevelChart extends ChartMixin {
  @Prop({ type: Object, required: true }) chartDataCurrent!: { x: number; y: number };
  @Prop({ type: Object, required: true }) chartDataLast!: { x: number; y: number; isDisp: boolean };
  @Ref("behavior-table") behaviorTable!: HTMLElement;
  @Ref("behavior-axis-current") behaviorAxisCurrent!: HTMLElement;
  @Ref("behavior-axis-last") behaviorAxisLast!: HTMLElement;
  calculatePositionCurrent(x: number, y: number) {
    x = Math.min(Math.max(x, 30), 70);
    y = Math.min(Math.max(y, 30), 70);
    this.$nextTick(() => {
      const tableWidth = this.behaviorTable.clientWidth;
      const tableHeight = this.behaviorTable.clientHeight;
      const borderSize = 1;
      const coefX = 0.25 * ((x - 30) / 10);
      const coefY = 0.25 * ((y - 30) / 10);
      const calcX = ((tableWidth * coefX) / tableWidth) * 100;
      const calcY = ((tableHeight * coefY) / tableHeight) * 100;
      (this.behaviorAxisCurrent.style.left = `calc(${calcX}% - ${(x >= 50 ? borderSize : -borderSize) + 5}px)`),
      (this.behaviorAxisCurrent.style.bottom = `calc(${calcY}% - ${(y >= 50 ? borderSize : -borderSize) + 5}px)`);
    });
  }

  calculatePositionLast(x: number, y: number) {
    x = Math.min(Math.max(x, 30), 70);
    y = Math.min(Math.max(y, 30), 70);
    this.$nextTick(() => {
      const tableWidth = this.behaviorTable.clientWidth;
      const tableHeight = this.behaviorTable.clientHeight;
      const borderSize = 1;
      const coefX = 0.25 * ((x - 30) / 10);
      const coefY = 0.25 * ((y - 30) / 10);
      const calcX = ((tableWidth * coefX) / tableWidth) * 100;
      const calcY = ((tableHeight * coefY) / tableHeight) * 100;
      (this.behaviorAxisLast.style.left = `calc(${calcX}% - ${(x >= 50 ? borderSize : -borderSize) + 5}px)`),
      (this.behaviorAxisLast.style.bottom = `calc(${calcY}% - ${(y >= 50 ? borderSize : -borderSize) + 5}px)`);
    });
  }
}
</script>
